export type StoreConnectionExtraField = {
    key: string;
    label: string;
    placeholder: string;
    value: string;
    onChange: (value: string) => void;
    placement?: 'before-store-url' | 'after-store-url';
    autoFocus?: boolean;
};

export type StoreConnectionFormItem =
    | { kind: 'store-url' }
    | { kind: 'extra-field'; field: StoreConnectionExtraField };

export const buildStoreConnectionFormItems = (
    extraFields: readonly StoreConnectionExtraField[],
): StoreConnectionFormItem[] => {
    const fieldsBeforeStoreUrl = extraFields.filter(
        (field) => field.placement === 'before-store-url',
    );
    const fieldsAfterStoreUrl = extraFields.filter(
        (field) => field.placement !== 'before-store-url',
    );

    return [
        ...fieldsBeforeStoreUrl.map((field) => ({
            kind: 'extra-field' as const,
            field,
        })),
        { kind: 'store-url' as const },
        ...fieldsAfterStoreUrl.map((field) => ({
            kind: 'extra-field' as const,
            field,
        })),
    ];
};
